module.exports = __webpack_public_path__ + "dec64563adb5b2860e307f7a358a94f4.MP3";